import { TIMESHEET_CONSTANTS } from '@app/pages/vendor-rep/timesheet/timesheet.constants';

export interface SortableTimesheetData {
  status: string | null;
  workingHrs: number;
  billableHrs: number;
  employeeName?: string;
}

export function sortByStatusPriority<T extends SortableTimesheetData>(
  data: T[], 
  componentType: 'vendor-rep' | 'vendor-management' = 'vendor-management'
): T[] {
  const getStatusPriority = (row: T): number => {
    if (row.status === null && row.workingHrs === 0 && row.billableHrs === 0) {
      return componentType === 'vendor-rep' ? 1 : 2;
    }
    switch (row.status) {
      case TIMESHEET_CONSTANTS.STATUS.PENDING_APPROVAL:
        return componentType === 'vendor-rep' ? 2 : 1;
      case TIMESHEET_CONSTANTS.STATUS.PENDING_SUBMISSION:
        return componentType === 'vendor-rep' ? 1 : 2;
      case TIMESHEET_CONSTANTS.STATUS.APPROVED:
        return 3;
      case TIMESHEET_CONSTANTS.STATUS.REJECTED:
        return 4;
      case null:
      default:
        return 5;
    }
  };

  return data.sort((a, b) => {
    const priorityA = getStatusPriority(a);
    const priorityB = getStatusPriority(b);
    
    if (priorityA !== priorityB) {
      return priorityA - priorityB;
    }
    
    return (a.employeeName || '').localeCompare(b.employeeName || '');
  });
}